/* React */
import React, { useMemo } from "react";

/* Utils */
import ChartWrapper from "src/utils/wrapper/chart-wrapper/ChartWrapper";

/* Components */
import HorizontalBoxplotOptions from "src/components/chart-wrapper/toolbar/options/horizontal-boxplot-options/HorizontalBoxplotOptions";
import HorizontalBoxplot from "src/components/charts/horizontal-boxplot/HorizontalBoxplot";
import Label from "src/components/charts/horizontal-boxplot/horizontal-boxplot-slide/label/Label";

/* Interfaces */
import { BoxplotProps } from "src/shared/interfaces/Boxplot";

interface BoxplotSliderProps {
  item: {
    name: string;
    data: BoxplotProps[];
  };
  index: number;
  selectedTLs: string[];
  handleSelectedTLs: (treatmentLines: string[]) => void;
  activeIndex?: number;
}

const HorizontalBoxplotSlide: React.FC<
  BoxplotSliderProps
> = ({
  item,
  index,
  selectedTLs,
  handleSelectedTLs,
  activeIndex,
}) => {
  /**
   * Filter boxplot data based on selected treatment lines (TLs).
   */
  const filteredData = useMemo(() => {
    return item.data.filter((entry) => {
      const match = entry.name.match(/\((TL\d+)\)/);
      const tl = match?.[1];
      return (
        !selectedTLs.length ||
        selectedTLs.includes(tl || "")
      );
    });
  }, [selectedTLs, item.data]);

  return (
    <ChartWrapper
      key={index}
      options={
        <HorizontalBoxplotOptions
          item={item}
          selectedTLs={selectedTLs}
          handleSelectedTLs={handleSelectedTLs}
          activeIndex={activeIndex}
        />
      }
      label={<Label label={item.name} />}
      downloadFilename={item.name}
    >
      {(height, width) => (
        <HorizontalBoxplot
          data={filteredData}
          dimension={{ height, width }}
        />
      )}
    </ChartWrapper>
  );
};

export default HorizontalBoxplotSlide;
